import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";


export const OffersLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListOffers') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreateOffer') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/offers'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetOffer') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/offers'/>
                    )
                }

            >
            </Route>


        </Routes>
    );
};
